<template>
    <ui-modal :id="id" 
        v-model="displayModal" 
        @shownModal="reviewModalAsBodyHandler">
        
        <template #header>
            {{ 'site-map' | staticTitle }}
        </template>

        <pre class="mermaidLoader">{{ 'site-map' | staticContent }}</pre>

    </ui-modal>
</template>

<script>
/* eslint-disable */
export default {
    name: 'SiteMapModal',
    props: {
        id: {
            type: String,
            default: 'site-map-modal'
        }
    },
    data: () => {
        return {
            displayModal: false
        }
    },
    methods: {
        async reviewModalAsBodyHandler() {
			console.log('reviewModalAsBodyHandler', this.displayModal)
			setTimeout(async () => {
				console.log('mermaid.run', window.mermaid)
				await window.mermaid.run({
					querySelector: '.mermaidLoader',
				});
			}, 100);
		},
        display() {
            this.displayModal = true;
        }
    }
}
</script>